import { type ColumnOptions } from "interfaces";
import styles from "./packListRow.module.scss";

export const getUserPackColumnOptions = (licenseRemovalEnabled: boolean): ColumnOptions[] => {
  const options: ColumnOptions[] = [
    {
      name: "Pack",
      width: 5,
      isSortable: true,
      className: styles["pack-title-header"],
    },
    {
      name: "License Issued",
      width: 4,
      isSortable: true,
    },
    {
      name: "Expiration Date",
      width: 4,
      isSortable: true,
    },
  ];

  if (licenseRemovalEnabled) {
    options.push({
      name: "",
      width: 1,
      isSortable: false,
    });
  }

  return options;
};
